// extracted by mini-css-extract-plugin
export default {"header":"Header_header__OKWO7","header__border_bottom":"Header_header__border_bottom__WV5GP"};